// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

// Other global configurations can be added here
